import { render, staticRenderFns } from "./RxInfoReview.vue?vue&type=template&id=03eab589"
import script from "./RxInfoReview.vue?vue&type=script&lang=js"
export * from "./RxInfoReview.vue?vue&type=script&lang=js"
import style0 from "./RxInfoReview.vue?vue&type=style&index=0&id=03eab589&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports